import {LitElement, css, html} from "lit";
import MaterialIconsFontStyle from "@fontsource/material-icons";

const style = document.createElement("style");
style.textContent = MaterialIconsFontStyle;
document.head.appendChild(style);

/**
 * Material Design Icon
 */
export class MdIcon extends LitElement {

	static get styles() {
		return css`
			:host {
				font-family: "Material Icons";
				font-weight: normal;
				font-style: normal;
				font-size: 24px; /* Preferred icon size */
				display: inline-block;
				line-height: 1;
				vertical-align: middle;
				text-transform: none;
				letter-spacing: normal;
				word-wrap: normal;
				white-space: nowrap;
				direction: ltr;
			
				/* Support for all WebKit browsers. */
				-webkit-font-smoothing: antialiased;
				/* Support for Safari and Chrome. */
				text-rendering: optimizeLegibility;
			
				/* Support for Firefox. */
				-moz-osx-font-smoothing: grayscale;
			
				/* Support for IE. */
				font-feature-settings: 'liga';
			}
		`;
	}

	render() {
		return html`<slot></slot>`;
	}

}

export default MdIcon;

customElements.define("md-icon", MdIcon);
